class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    console.log('opening')
    console.log(this.notification.classList)
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.productKey = parsedState.key
      this.getSectionsToRender().forEach((section => {
        console.log('section')
        console.log(section)
        console.log('getting')
        console.log(document.getElementById(section.id))
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productKey}`,
      },
      {
        id: 'cart-notification-button'
      },
      // {
      //   id: 'cart-icon-bubble'
      // }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    console.log(typeof html)
    console.log(html)
    console.log('---')
    console.log(selector)
    const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
    console.log('parsed')
    console.log(parsedHtml)
    console.log(`[id='${selector.slice(1, selector.length)}']`)
    if(selector.includes("cart-notification-product")){
      selector = `[id='${selector.slice(1, selector.length)}']`
    }
    const innerHtml = parsedHtml.querySelector(selector).innerHTML;
    console.log('inner')
    console.log(innerHtml)
    return innerHtml
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
